import type { ReactNode } from 'react';
import { cn } from '@rocco/utils/cn';

export interface SectionLabelProps {
    /** Eyebrow text, e.g. "(01 – Projects)", "(About)", "(04 – Articles)". */
    children: ReactNode;
    className?: string;
}

/**
 * Small eyebrow label that prefixes homepage sections (Neue Haas Roman ~28px
 * on the 1920 frame, sized in vw so it scales with the section). Defaults to
 * the dark ink colour; pass `text-white` via className on dark sections.
 * Positioning is left to the consuming section.
 */
export const SectionLabel = ({ children, className }: SectionLabelProps) => (
    <span
        className={cn(
            'font-sans font-normal leading-[1.07] tracking-[-0.044em] text-[#181818] max-md:text-[2.21vw] md:text-[1.458vw]',
            className,
        )}
    >
        {children}
    </span>
);
